import { Grid } from "@mui/material";
import { formatNumber } from "utils/formatNumber";

const ScriptSharesSection = ({ data }) => {
  return (
    <div className='section script-shares-section'>
      <Grid className='p-0' container spacing={2}>
        <Grid item xs={12}>
          <div className='grid-item-container'>
            <span className='title'>Total Shares</span>
            <span className='value'>
              {formatNumber.toAmount(data?.total_shares ?? 0)}
            </span>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className='grid-item-container'>
            <span className='title text-sm'>Script</span>
            <span className='value text-sm'>
              {`${formatNumber.toAmount(data?.script_shares ?? 0)} (${(
                data?.percentage_script ?? 0
              )?.toFixed(2)}%)`}
            </span>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className='grid-item-container'>
            <span className='title text-sm'>Scriptless</span>
            <span className='value text-sm'>
              {`${formatNumber.toAmount(data?.scriptless_shares ?? 0)} (${(
                data?.percentage_scriptless ?? 0
              )?.toFixed(2)}%)`}
            </span>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ScriptSharesSection;
